const ACTION_TYPES_SEARCH = {
  GET_TOPIC_BY_SEARCH: Symbol("GET_TOPIC_BY_SEARCH"),
  GET_TOPIC_BY_SEARCH_SUCCESS: Symbol("GET_TOPIC_BY_SEARCH_SUCCESS"),
  GET_TOPIC_BY_SEARCH_FAILED: Symbol("GET_TOPIC_BY_SEARCH_FAILED"),
  CHOOSE_TAB: Symbol("CHOOSE_TAB"),
  OPEN_MODAL_JOIN_QUIZ: Symbol("OPEN_MODAL_JOIN_QUIZ")
};

export default ACTION_TYPES_SEARCH;
